<template>
   <!-- <div style="display: flexbox;">
    <div class="page-email-sync-container">
      <div class="top-section">
        <h4>Sync with Outlook 365</h4>
      </div>
      <br>
      <img class="email-logo" @click="processMailbox(2)" src="../../assets/logos/outlook365.png" />
      <div class="bottom-section" :v-if="showshowChangeAddress">
        <div class="get-started">
          <div class="body-l">
            To get started, click the icon above ☝️ - you will be asked to authenticate VentureStar.Email to access your
            inbox for processing
          </div>

        </div>

     
      </div>
    </div>
    <div class="page-email-sync-container">
      <div class="top-section">
        <h4>Sync with Gmail</h4>
      </div>
      <br>
      <img class="email-logo" @click="processMailbox(1)" src="../../assets/logos/Gmail_icon_(2020).svg.png" />
      <div class="bottom-section" :v-if="showshowChangeAddress">
        <div class="get-started">
          <div class="body-l">
            To get started, click the icon above ☝️ - you will be asked to authenticate VentureStar.Email to access your
            inbox for processing
          </div>

        </div>

        
      </div>
    </div>
  </div>  -->


  <div>
    <div class="explanation">
      <img width="240" src="../../assets/logos/downloademails.png" alt="Download Email Data">
      <h2 class="page-title">Download email data</h2>
      <div>Download data from your online mailbox to EmPerA.</div>
    </div>
    <div class="email-options">
      <div class="option">
        <img class="email-logo" @click="processMailbox(1)" src="../../assets/logos/Gmail_icon_(2020).svg.png" />
        <button class="button" @click="processMailbox(1)">Sync with Gmail</button>
      </div>
      <div class="option">
        <img class="email-logo" @click="processMailbox(2)" src="../../assets/logos/outlook365.png" />
        <button class="button" @click="processMailbox(2)">Sync with Outlook 365</button>
      </div>
    </div>

  </div>
</template>

<script setup>

import { ref, computed, watch } from "vue";
import { useStore } from "vuex";

const store = useStore();

const emailKnowledgeBasePopulated = computed(() => store.getters.emailKnowledgeBase.KB.length > 0 ? true : false);


let intelligentEmailAddress = computed(
  () => store.getters.intelligentEmailAddress
);

const showshowChangeAddress = useStore(() => false);

let pollInterval = null;

function processMailbox(provider) {
  store.dispatch("ProcessMailbox", provider);

if (!emailKnowledgeBasePopulated)
{
    if (pollInterval) {
      clearInterval(pollInterval);
    }

    pollInterval = setInterval(async () => {
      await store.dispatch("emailKnowledgeBaseNode");
      store.dispatch("emailModelTags")
    }, 10000);

    const stopWatch = watch(emailKnowledgeBasePopulated, (newVal) => {
      if (newVal) {
        if (pollInterval) {
          clearInterval(pollInterval);
          pollInterval = null;
        }
        stopWatch();
      }
    });
  }
}


// const setNewAddressName = (newName) => {
//   store.dispatch("putIntelligentEmailAddress", newName + "@venturestar.email");
// };

// store.dispatch('putIntelligentEmailAddress', 'zackk@venturestar.email');
</script>

<style scoped lang="scss">
.explanation {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0 3rem 0;

}

.page-title {
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0 0 1rem 0;
}

.button {
  background-color: #eee; 
  width: 100%;
  border: none;
  color: #000;
  padding: 16px 24px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-top: 1rem;
  border-radius: 5px;
  border: 1px solid #c1c1c1;
  cursor: pointer;

  &:hover {
    background-color: #ddd;
  }
}

.email-options {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8rem;
  margin-top: 2rem;
  & .option {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
}

.email-logo {
  height: 140px;
  cursor: pointer;
}

.email-logo:hover {
  // scale: 1.2;
  cursor: grab;
}

.get-started {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

h6 {
  font-size: 18px;
  font-weight: 400;
}


.page-email-sync-container {
  margin: 2rem 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.bottom-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  gap: 2rem;
  max-width: 600px;
  margin-top: 20px;
  padding: 10px 16px;
}

.message {
  position: absolute;
  background-color: rgb(0, 0, 0);
  color: #fff;
  padding: 4px 8px;
  font-size: 80%;
  // width: 70px;
  border-radius: 7px;
  left: -6px;
  top: -30px;
  opacity: 0;
}

.visable {
  opacity: 1;
}

.send-email-container {
  width: 300px;
  height: 30px;
  border: 1px solid rgb(173, 173, 173);
  border-radius: 5px;
  background-color: rgb(245, 245, 245);
  display: flex;
  justify-content: space-between;
  // padding: 0px 15px;
}

.icon {
  position: relative;
  border-left: 1px solid rgb(173, 173, 173);
  padding: 5px 15px;

  &:hover {
    cursor: pointer;
  }
}

.email {
  padding: 5px 15px;
}

.edit-email-address {
  align-self: center;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
